import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "head" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_BuilderInputs = _resolveComponent("BuilderInputs")
  const _component_Button = _resolveComponent("Button")
  const _component_Loader = _resolveComponent("Loader")
  const _component_Modal = _resolveComponent("Modal")

  return (_openBlock(), _createBlock(_component_Modal, {
    ref: "modal",
    "modal-to": "#chat",
    max_width: "48rem",
    centered: false
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[2] || (_cache[2] = _createTextVNode(" Save Prompt ")),
          _createVNode(_component_Icon, {
            class: "pointer",
            disabled: $data.loading,
            icon: "x-close",
            stroke: "var(--gray-400)",
            height: "2rem",
            width: "2rem",
            onClick: $options.onCancel
          }, null, 8 /* PROPS */, ["disabled", "onClick"])
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "description" }, " Give your prompt a name and make any edits before saving. ", -1 /* HOISTED */))
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_BuilderInputs, {
        "vread-from": "valid",
        "onUpdate:valid": $event => (($data.valid) = $event),
        class: "builder",
        opts: $data.schema
      }, null, 8 /* PROPS */, ["onUpdate:valid", "opts"])
    ]),
    controls: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "create-btn",
        disabled: $data.loading,
        onClick: _cache[0] || (_cache[0] = $event => ($options.onCancel()))
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [
          _createTextVNode(" Cancel ")
        ])),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"]),
      _createVNode(_component_Button, {
        primary: "",
        class: "create-btn",
        disabled: !$options.can_save || $data.loading,
        onClick: _cache[1] || (_cache[1] = $event => ($options.savePrompt()))
      }, {
        default: _withCtx(() => [
          ($data.loading)
            ? (_openBlock(), _createBlock(_component_Loader, {
                key: 0,
                color: "var(--base-white)",
                inline: "",
                mini: ""
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode(" Save Prompt ")
              ], 64 /* STABLE_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["disabled"])
    ]),
    _: 1 /* STABLE */
  }, 512 /* NEED_PATCH */))
}